import { z } from 'zod';
import { BaseValidatorSchema } from '../base-validator-schema';

export const MinimumTimeDistanceValidator = z.literal('minimumTimeDistance');
export type TMinimumTimeDistanceValidator = z.infer<typeof MinimumTimeDistanceValidator>;

export const MinimumTimeDistanceValidatorParamsSchema = z.object({
  timeValue: z.number(),
  timeUnit: z.enum(['days', 'months', 'years']),
  valueDestination: z.string().optional(),
});

export type TMinimumTimeDistanceValidatorParams = z.infer<
  typeof MinimumTimeDistanceValidatorParamsSchema
>;

export const MinimumTimeDistanceValidatorSchema = BaseValidatorSchema.extend({
  type: MinimumTimeDistanceValidator,
  value: MinimumTimeDistanceValidatorParamsSchema,
});
